export default __webpack_public_path__ + "static/media/icon-cadastro.4564103b.svg";